// =============================================================================
// CONNEXION TERRAIN — l'écran d'entrée de `visite.omnihub-ia.fr`
// =============================================================================
// 🔴 POURQUOI IL EXISTE, mesuré le 2026-09-20 (N°474/N°475) : JJ ouvre
// `visite.omnihub-ia.fr` et lit « Authentification requise ». ⛔ UN CONSTAT,
// ⛔ PAS UN GESTE — ⛔ aucun champ, ⛔ aucune issue. Mario était dans une
// impasse au TOUT PREMIER écran de la V1.
//
// ⚠️ LE 401 EST CORRECT ET ⛔ N'EST PAS TOUCHÉ. La cause est ailleurs, et elle
// est NORMALE : le cookie `session_token` est posé SANS `Domain`
// (`marketing/routes.py:318`) et `localStorage` est PAR ORIGINE. Une session
// ouverte sur `omnihub-ia.fr` ⛔ ne SUIT donc PAS sur le sous-domaine — et
// ⛔ elle ⛔ ne DOIT pas : un cookie élargi au domaine parent exposerait la
// session de l'ERP à tous les sous-domaines. ⇒ On ⛔ ne contourne RIEN :
// ⛔ ON SE CONNECTE ICI, et le cookie se pose sur CETTE origine.
//
// 🔑 ⛔ CE N'EST PAS UN SECOND ÉCRAN DE CONNEXION AU SENS OÙ LE CTO L'INTERDIT.
// Il ⛔ n'y a AUCUN second chemin d'authentification : on appelle
// `useAuth().loginWithEmail` — LA MÊME autorité que l'ERP, celle qui pose la
// session, écrit `current_tenant_slug` et gère `must_change_password`.
// ⚠️ Le formulaire de l'ERP ⛔ n'était PAS réutilisable : il vit EN LIGNE dans
// `OmniHub.jsx` (3245 lignes), ⛔ pas dans un composant. L'en extraire aurait
// été un refactor de l'écran principal à la veille d'une livraison. ⇒ On
// réutilise LE MÉCANISME, ⛔ pas le balisage.
//
// ⛔ LE TENANT ⛔ NE VIENT JAMAIS DE L'URL (N°468). Il vient de l'utilisateur
// authentifié — `users.current_tenant`, l'autorité mesurée. Un sous-domaine
// ⛔ ne doit PAS devenir une seconde autorité tenant.
// =============================================================================
import { useState } from "react";
import { Loader2, LogIn } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

export default function ConnexionTerrain({ titre = "Visite terrain" }) {
  const { loginWithEmail } = useAuth();
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState("");
  const [occupe, setOccupe] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur(""); setOccupe(true);
    try {
      await loginWithEmail(email.trim(), motDePasse);
      // ⛔ AUCUNE redirection ici : `AuthProvider` pose `user`, et l'écran
      // terrain se monte de lui-même. Rediriger ferait recharger la page et
      // perdrait le contexte que l'on vient d'établir.
    } catch (err) {
      // 🔴 LE MOTIF EST DIT. ⛔ Un « erreur » nu laisserait Mario deviner s'il
      // s'est trompé de mot de passe ou si le serveur est tombé.
      setErreur(err?.message || "Connexion impossible. Vérifiez vos identifiants.");
    } finally { setOccupe(false); }
  };

  const champ = {
    width: "100%", minHeight: 48, borderRadius: 12, padding: "0 14px",
    fontSize: 16,                       // 🔑 16px : en dessous, iOS zoome.
    border: "0.5px solid var(--oh-border)",
    background: "var(--oh-bg-surface)", color: "var(--oh-text)",
  };

  return (
    <div style={{ background: "var(--oh-bg)", color: "var(--oh-text)",
                  minHeight: "100vh", display: "flex",
                  alignItems: "center", justifyContent: "center",
                  padding: 16 }}
         data-testid="connexion-terrain">
      <form onSubmit={soumettre}
            style={{ width: "100%", maxWidth: 380,
                     background: "var(--oh-bg-elevated)",
                     border: "0.5px solid var(--oh-border)",
                     borderRadius: 12, padding: 24 }}>
        <div style={{ fontWeight: 500, fontSize: 20, marginBottom: 4 }}>
          {titre}
        </div>
        <div style={{ fontSize: 13, color: "var(--oh-text-secondary)",
                      marginBottom: 20, lineHeight: 1.6 }}>
          Connectez-vous pour accéder à vos visites.
        </div>

        <label htmlFor="ct-email" style={{ fontSize: 13, display: "block",
                                           marginBottom: 4 }}>
          Adresse e-mail
        </label>
        <input id="ct-email" type="email" required autoComplete="username"
               inputMode="email" autoCapitalize="none" autoCorrect="off"
               data-testid="connexion-email"
               value={email} onChange={(e) => setEmail(e.target.value)}
               style={{ ...champ, marginBottom: 14 }} />

        <label htmlFor="ct-mdp" style={{ fontSize: 13, display: "block",
                                         marginBottom: 4 }}>
          Mot de passe
        </label>
        <input id="ct-mdp" type="password" required
               autoComplete="current-password"
               data-testid="connexion-mot-de-passe"
               value={motDePasse}
               onChange={(e) => setMotDePasse(e.target.value)}
               style={{ ...champ, marginBottom: 18 }} />

        {erreur && (
          <div data-testid="connexion-erreur"
               style={{ background: "var(--oh-error-bg)",
                        color: "var(--oh-error-text)", borderRadius: 8,
                        padding: "10px 12px", fontSize: 13, marginBottom: 14,
                        lineHeight: 1.6 }}>
            {erreur}
          </div>
        )}

        <button type="submit" disabled={occupe}
                data-testid="connexion-valider"
                style={{ width: "100%", minHeight: 48, borderRadius: 12,
                         border: "none", fontSize: 16,
                         display: "flex", alignItems: "center",
                         justifyContent: "center", gap: 8,
                         background: "var(--oh-accent-solid)",
                         color: "var(--oh-accent-contrast)",
                         opacity: occupe ? 0.6 : 1 }}>
          {occupe ? <Loader2 size={18} className="animate-spin" />
                  : <LogIn size={18} />}
          {occupe ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
